import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Breadcrumbs, Link, Typography, CircularProgress } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import BASE_API_URL from '../apis/index';
import UserCompanyRegistrationForm from '../components/UserCompanyRegistrationForm';

export default function UserCompanyDetailsEdit() {
    const [searchParams] = useSearchParams();
    const compId = searchParams.get("compId");
    const compName = searchParams.get("compName");

    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!compId) return;

        const fetchCompany = async () => {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(
                    `${BASE_API_URL}/api/seller/company/${compId}`,{
                        headers: { Authorization: `Bearer ${authToken}` },
                    }
                );

                // if (res.data.status === "ok") {
                const company = res.data;

                // 🔹 Transform API response into formData format
                const transformed = {
                    companyName: company.company_name || "",

                    companyLogo: null,   // new upload
                    existingCompanyLogo: company.company_logo || null, // existing

                    companyImages: [],   // new uploads
                    existingCompanyImages: company.company_images ? JSON.parse(company.company_images) : [],

                    countryOfOrigin: company.country_of_origin ? { label: company.country_of_origin, value: company.country_of_origin } : null,
                    address: company.address || "",
                    companyTypes: company.company_types ? JSON.parse(company.company_types) : [],
                    brief: company.brief || "",
                    countryCode: null, // not in API
                    mobileInput: "",
                    emailInput: "",
                    mobileNumbers: company.mobile_numbers ? JSON.parse(company.mobile_numbers) : [],
                    emails: company.emails ? JSON.parse(company.emails) : [],

                    panNumber: company.pan_number || "",
                    gstNumber: company.gst_number || "",
                    cinCode: company.cin_code || "",
                    annualTurnover: company.annual_turnover || "",
                    vendorStatus: company.vendor_status || "",
                    vendorType: company.vendor_type || "",

                    cinDoc: null,
                    existingCinDoc: company.cin_doc || null,

                    rcDoc: null,
                    existingRcDoc: company.rc_doc || null,

                    llpCert: null,
                    existingLlpCert: company.llp_cert || null,

                    panDoc: null,
                    existingPanDoc: company.pan_doc || null,

                    gstDoc: null,
                    existingGstDoc: company.gst_doc || null,

                    accountNumber: company.account_number || "",
                    ifsc: company.ifsc || "",
                    branch: company.branch || "",
                    bank: company.bank || "",
                    accountHolderName: company.account_holder_name || "",
                    consent: company.consent === 1 ? true : false,
                };

                setFormData(transformed);
                // }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchCompany();
    }, [compId]);

    return (
        <Wrapper className='container'>
            <Breadcrumbs aria-label="breadcrumb" className="mb-5 mt-2 pageBreadCrumbs">
                <Link underline="hover" color="inherit" href="/user-companies"> Companies </Link>
                <Link underline="hover" color="inherit" href={`/user-company-details?compId=${compId}`}> { compName ? compName : "" } </Link>
                <Typography sx={{ color: "text.primary" }}> Edit Company </Typography>
            </Breadcrumbs>

            <h2 className="pageTitle after_title_line"> <span> Edit your company </span>{" "} </h2>
            <p className='statusBox'> Edited company details also will be verified and approved by admin, it will take a while. </p>

            {loading ? (
                <CircularProgress />
            ) : formData ? (
                <UserCompanyRegistrationForm
                    initialData={formData}
                    mode="edit"
                    compId={compId}
                />
            ) : (
                <p>Company not found.</p>
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
.statusBox{
    background: var(--bg-color);
    border-left: 6px solid var(--secondary-color);
    padding: 4px 10px;
    color: var(--primary-color);
    margin-bottom: 20px;
}
`;
